import React from 'react';
import { Clearfix } from 'react-bootstrap';
import LinkOrSpan from './LinkOrSpan';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import Rating from 'components/Rating/Rating';
import { calculateUserRating } from 'helpers/HelperFunctions';
import Verified from 'components/Badges/Verified/Verified';
import Pro from 'components/Badges/Pro/Pro';
import useAuth from 'hooks/useAuth';

const UserSnippet = ({ active, user: viewedUser }) => {
  const { user: authUser } = useAuth();
  const user = viewedUser || authUser;

  const { avatars, displayname, links, rating } = user;

  return (
    <Clearfix>
      <div
        className="left"
        style={{
          marginRight: '10px',
        }}
      >
        <LinkOrSpan
          active={active}
          linkProps={{
            to: links.main_relative,
            className: 'no-decoration',
          }}
        >
          <Thumbnail
            thumbnails={avatars}
            circle
            style={{
              width: '46px',
              height: '46px',
            }}
          />
        </LinkOrSpan>
      </div>

      <div>
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <LinkOrSpan
            active={active}
            linkProps={{
              to: links.main_relative,
              className: 'no-decoration',
            }}
          >
            <strong>{displayname}</strong>
            <span
              style={{
                marginLeft: '5px',
              }}
            >
              <Verified user={user} />
            </span>
            <span
              className="hidden-xs"
              style={{
                marginLeft: '5px',
              }}
            >
              <Pro user={user} />
            </span>
          </LinkOrSpan>
        </div>

        <Rating rating={calculateUserRating(user)} className="fs-18 left" />

        {rating.count > 0 && (
          <span
            style={{
              verticalAlign: 'sub',
              fontSize: '16px',
            }}
          >{`(${rating.count})`}</span>
        )}
      </div>
    </Clearfix>
  );
};

export default UserSnippet;
